import React from "react";
import BlockTitle from "../block-title";

const HeroHeaderTeaching = ({ tagLine1, title1 }) => {
  return (
    <div className="flex justify-between  flex-col sm:flex-col">
      <div className="lg:flex-1 flex-none leading-tight">
        <BlockTitle title={tagLine1} tagLine={title1} />
      </div>
    </div>
  );
};

export default HeroHeaderTeaching;
